module.exports = __webpack_public_path__ + "static/media/7.9e806121.jpg";